import React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import AmbuNetLogo from '../../assets/images/ambunetLogo.png'

const PoweredBySmall = ({ direction }) => (
  <Stack
    direction={direction || 'row'}
    spacing={1}
    alignItems="center"
    justifyContent="center"
    sx={{ opacity: 0.85, cursor: 'pointer' }}
    onClick={() => window.open('https://ambunet.co.uk')}
  >
    <Typography variant="caption" color="text.secondary">
      Securely powered by
    </Typography>
    <Box
      component="img"
      src={AmbuNetLogo}
      alt="AmbuNet"
      sx={{
        height: 16,
        objectFit: 'contain',
      }}
    />
    <Stack direction="row">
      <Typography
        variant="caption"
        color="text.secondary"
        fontFamily="moonlander"
        fontSize="0.75rem"
      >
        AmbuNet
      </Typography>
      <Typography variant="caption" color="text.secondary">
        &#174;
      </Typography>
    </Stack>
  </Stack>
)

export default PoweredBySmall
